import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'default' | 'large';
}
export function CTAButton({
  text = 'Sí, quiero enseñar con claridad',
  className = '',
  fullWidth = false,
  variant = 'primary',
  size = 'default'
}: CTAButtonProps) {
  const scrollToPurchase = () => {
    const section = document.getElementById('purchase-section');
    if (section) {
      const yOffset = -100;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-gray-900 border-2 border-transparent',
    secondary: 'bg-white text-indigo-900 border-2 border-white hover:bg-indigo-50',
    danger: 'bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-gray-900'
  };
  const sizes = {
    default: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg md:text-xl'
  };
  return <button onClick={scrollToPurchase} className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} data-id="element-28">
      <span className="font-bold" data-id="element-29">{text}</span>
      <ArrowRight className="ml-2 w-4 h-4 stroke-[2.5]" data-id="element-30" />
    </button>;
}